'use client';
import { Typography } from '@curology/ui-components-web/react';
import Image from 'next/image';
import React from 'react';

import { type PriceSummaryItemType } from '../types';
import { getFormattedPrice } from '../utils';

export const PriceSummaryItem = ({
  isFirstItem,
  priceSummaryItem,
}: {
  isFirstItem?: boolean;
  priceSummaryItem: PriceSummaryItemType;
}) => {
  return (
    <li
      className={`cur-border-disabled cur-border-solid cur-flex ${isFirstItem ? '' : 'cur-border-t cur-mt-4 cur-pt-4'}`}
    >
      <div className="cur-h-[50px] cur-mr-4 cur-relative cur-w-[40px]">
        <Image
          alt={priceSummaryItem.thumbnailImage.altText}
          height={400}
          quality={100}
          src={priceSummaryItem.thumbnailImage.url}
          width={500}
        />
      </div>
      <div className="cur-flex-1 cur-mr-4">
        <Typography weight="bold">
          {priceSummaryItem.name}
          {priceSummaryItem.isRx ? <sup>Rx</sup> : ''}
        </Typography>
        <Typography>{priceSummaryItem.description}</Typography>
      </div>
      <div className="cur-flex-none cur-text-right">
        <Typography className="cur-uppercase" weight="bold">
          {getFormattedPrice(priceSummaryItem.price.final)}
        </Typography>
        <Typography className="cur-line-through cur-text-disabled">
          {getFormattedPrice(priceSummaryItem.price.original)}
        </Typography>
      </div>
    </li>
  );
};
